// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BdeC","title":"Info_title__nznoO","selects":"Info_selects__dtoJi","requiredAsterisk":"Info_requiredAsterisk__1nbr0"};